// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function requestSolicitationDetail(solicitationId) {
  // Format query
  const query = `
  query getSolicitationDetail($id: ID!) {
    solicitation(id: $id) {
      solicitation {
        id
        attachmentLinks
        designation
        issueDate
        returnDate
        solicitationLink
        castingType
        srva
        material
        method
        setAside
        issuedBy
        um
        quotable 
        amc
        estValue
        
        purchaseRequest {
          number
          quantity
          nsnPart
          fscCode
          fscName
          nomenclature,
          techDocsLink
          status
          
        }
        materialsMethods{
          material
          method
        }
        solicitationTab
        {  
          mypn, 
          description
          material
          method
          process
          mold
          nsn
          dla
          amc
          pic
          srva
          pkg 
          standardCost
          um 
   }
     
    drawings
   {
     tyNo
     cage
     rev
     licAgmt
     drawingNo
     files
     docDate
     title
     type
     revDate
     exportCtrl
     fgnSecure
     docDataCd
   }  
       
       
        procurementHistory
          {
            cage
            quantity
            contractNumber
            awardedDate
            unitCost
            supplierName
            um   
         }

         wsdcs 
         {
          wsdc
          wsec
          wsic
          wsgc
          wsName
         } 
         
         refNbrs
         {
          cage
          refNbr
          rncc
          rnvc
          dac
          rnsc
          hcc
          mscs
         }

 recentSolicitations
   {
     agency
     buyer
     closes
     phoneEMail
     quantity
     small
     solicitation
     status
     um       
   }  
       
       techInfo
       itemDescInfo
       packagingInfo         

      }
    }
  }`;

  const solicitationDetail = await makeGraphQLRequest({
    query,
    variables: {
      id: solicitationId,
    },
  });
  return solicitationDetail;
}

export default {
  requestSolicitationDetail,
};

export async function solicitationStatus(solicitationId) {
  const query = `query solicitationStatus($solicitationId: String) { solicitationStatus (solicitationId: $solicitationId) { status } }`;

  // Variables
  const variables = { solicitationId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/pages/SolicitationDetail/graphql.js